import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
  backgroundColorValue?: string;
  rotationValue?: string;
}

export const Root = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  padding: 0px 4px;
`;

export const IconContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 31px;
  border-radius: 5px;
  background-color: ${(props: IFontProps) => (props.backgroundColorValue ? props.backgroundColorValue : 'auto')};
  &:hover {
    background-color: ${C.DARK_BLUE};
  }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  z-index: 10;
  top: 49px;
  left: -5px;
  width: 170px;
  height: 116px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  height: 58px;
`;

export const IconList = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 31px;
  border-radius: 5px;
  margin: 0px 20px 0px 15px;
  background-color: ${(props: IFontProps) => (props.backgroundColorValue ? props.backgroundColorValue : 'auto')};
  transform: rotate(${(props: IFontProps) => (props.rotationValue ? props.rotationValue : '0')}deg);
  &:hover {
    background-color: rgba(18, 36, 66, 0.1);
  }
`;

export const Text = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`;